import { useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";
import { Input } from "@/components/ui/input";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { getApiUrl } from "@/utils/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Retrieve() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsSubmitting(true);

    try {
      const response = await fetch(getApiUrl("/password_reset/"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage(
          "Por favor, revisa tu correo electrónico con las instrucciones para restablecer tu contraseña",
        );
      } else {
        setError("Ha ocurrido un error. Por favor, inténtalo de nuevo.");
      }
    } catch (err) {
      setError("Ha ocurrido un error. Por favor, inténtalo de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 gap-4">
      <Card className="w-full max-w-md bg-white">
        <div className="flex justify-center py-8">
          <img src={logo} alt="Logo" className="h-16" />
        </div>
      </Card>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-center">
            {t("common.retrieve")}
          </CardTitle>
          <CardDescription className="text-center">
            {t("common.retrieve-description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="email">Email</label>
              <Input
                id="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
            {message && <p className="text-green-500 text-sm">{message}</p>}
            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {t("common.send")}
            </Button>
            <Button
              type="button"
              variant="diagonal"
              className="w-full"
              onClick={() => navigate("/login")}
            >
              {t("common.back-login")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
